<template>
  <div style="text-align: center">
    <!-- slot for parent component to activate the file changer -->
    <div
      style="
        width: 166px;
        display: inline-block;
        overflow: hidden;
        text-align: center;
        cursor: pointer;
      "
      @click.stop="launchFilePicker()"
    >
      <slot name="activator"></slot>
    </div>
    <div v-if="errorDialog">
      <small class="red--text">*{{ errorText }}</small>
    </div>
    <!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->
    <input
      type="file"
      ref="file"
      :name="uploadFieldName"
      @change="detectFiles($event)"
      style="display: none"
    />
  </div>
</template>

<script>
import firebase from '@firebase/app'
import '@firebase/storage'
import '@firebase/firestore'
export default {
  name: 'ImageInput',
  props: {
    value: String
  },
  data: () => ({
    errorDialog: false,
    errorText: '',
    uploadFieldName: 'file',
    maxSize: 1024,
    uploadTask: ''
  }),
  methods: {
    launchFilePicker() {
      this.$refs.file.click()
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files
      Array.from(Array(fileList.length).keys()).map(f => {
        this.upload(fileList[f])
      })
    },
    upload(file) {
      const storage = firebase.storage()
      this.$emit('update:fileNameUploaded', file.name)
      this.uploading = true
      this.uploadTask = storage
        .ref(this.pathToFiles + '/' + file.name)
        .put(file)
    }
  },
  watch: {
    uploadTask: function () {
      this.uploadTask.on(
        'state_changed',
        sp => {
          this.progressUpload = Math.floor(
            (sp.bytesTransferred / sp.totalBytes) * 100
          )
        },
        null,
        () => {
          this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            this.$root.$emit('imageUpload', downloadURL)
          })
        }
      )
    }
  }
}
</script>

<style></style>
